import { Injectable, } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient, HttpInterceptor, HttpHeaders, HttpParams } from '@angular/common/http';
// import { ElectronService } from 'ngx-electron';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { ElectronService } from './electron.service';

import { SERVER_PATH, SERVER_PATH_DEV } from '../config';

import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class GetinfoService {

  serverPath: string = SERVER_PATH;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    public commonService: CommonService,
    public electronService: ElectronService
  ) {

    if(this.electronService.isElectron) {
      let serve = this.electronService.ipcRenderer.sendSync("requestWhetherServe");
      if(serve) {
          this.serverPath = SERVER_PATH_DEV;
      }
    }
  }

  async sendDataPost(path: string, data: any = []) {
    let token = localStorage.getItem('userToken');
    let headers = new HttpHeaders({
      'Accept': 'application/x-www-form-urlencoded',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${token}`
    });
    let postData: any = this.serialize(data);
    let res = await this.http.post(this.serverPath + path, postData, { headers: headers }).toPromise().catch(e => console.log(e));
    
    return res;
  }

  makeMemberToken() {
    return new Promise((resolve,reject) => {
      let today = new Date();
      let currentdate = this.datePipe.transform(today,"yyyyMMdd");
      let myinfostr = localStorage.getItem('myinfo');

      if(myinfostr != '' && myinfostr != undefined) {
        let myinfo: any = JSON.parse(localStorage.getItem('myinfo'));
        let token = "";

        let str = currentdate + myinfo.salt + myinfo.idx;
        token = CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex);
        // console.log(token);
        resolve(token);
      }
      else {
        reject(new Error('Not logged in'));
      }

    });
  }

  sendNoneAuthPost(path:string, data:any) {

    // console.log(this.serverPath);
    return new Promise(resolve => {
      // let currentDate = new Date();
      // let currentDay = currentDate.toISOString().substr( 0, 10 );
      // let apikey = sha1('suyoung' + currentDay);

      let headers = new HttpHeaders({
        'Accept': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/x-www-form-urlencoded',
      });

      let body:any = data;
      this.http.post(this.serverPath + path, JSON.stringify(body), { headers: headers }).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });

  }

  async getApiData(path, body) {
    const headers = new HttpHeaders()
    .append('Accept','application/x-www-form-urlencoded')
    .append('Content-Type', 'application/x-www-form-urlencoded')
    let res = await this.http.post(this.serverPath + path, body, { headers: headers }).toPromise().catch(e => console.log(e));
    
    return res;
  }

  //리플레쉬 토큰
  async refreshToken(uid) {
    let today = new Date();
    let currentdate = this.datePipe.transform(today, 'yyyyMMdd');
    let str = currentdate + uid;
    let postData = {
      token: CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex)
    };
    await this.getApiData('/refreshtoken',JSON.stringify(postData)).then((res:any) => {
      // console.log('token',res.token);
      localStorage.setItem('myinfo',JSON.stringify(res.cominfo));
      localStorage.setItem('userToken',res.token);
    }).catch(e => console.log(e));
  }

  //body 데이터 전환
  serialize(obj: any): string {
    let params: URLSearchParams = new URLSearchParams();
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            var element = obj[key];

            params.set(key, element);
        }
    }
    let res: string = params.toString();
    
    return res;
  }

  download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    })
  }
}
